import CreatorProfile from "./CreatorProfile";

export default function IllusionistzProfile() {
  return (
    <CreatorProfile
      creatorId={7}
      categoryLabel="Urban Cinematic"
      onlyMemberzSlug="illusionistz"
      tags={["Urban", "Music", "Branded", "Promo"]}
    />
  );
}
